module.exports = __webpack_public_path__ + "img/平台生态@1x.998d5f46.png";